// extracted by mini-css-extract-plugin
export var blue = "#006bb2";
export var checkbox = "e_Q_cm";
export var large = "e_Q_cn";
export var medium = "e_Q_bS";
export var red = "#d14252";
export var teal = "#00bcd6";